import { createGlobalStyle, css } from "styled-components";

import {
  dividerStyles,
  miscStyles,
  muiOverridesStyles,
  resetStyles,
  scrollbarStyles,
  tableCellsStyles,
  tooltipsStyles,
  utilityClassesStyles,
} from "./global-styles";

export const AppGlobalStyles = createGlobalStyle<{ $isRtl: boolean }>`
  ${resetStyles}
  ${utilityClassesStyles}
  ${muiOverridesStyles}
  ${scrollbarStyles}
  ${miscStyles}
  ${tableCellsStyles}
  ${tooltipsStyles}
  ${dividerStyles}

  ${props =>
    props.$isRtl &&
    css`
      .rtl_rotate {
        transform: scaleX(-1);
      }
    `}

  ${({ $isRtl }) =>
    $isRtl &&
    `
      .MuiPickersCalendarHeader-labelContainer {
        margin-left: auto;
        margin-right: 0;
      }
    `}
`;
